import { render } from "./SeleccionarComercio.vue?vue&type=template&id=f458501a&scoped=true"
import script from "./SeleccionarComercio.vue?vue&type=script&lang=js"
export * from "./SeleccionarComercio.vue?vue&type=script&lang=js"

import "./SeleccionarComercio.vue?vue&type=style&index=0&id=f458501a&lang=scss&scoped=true"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f458501a"]])

export default __exports__